// export const QUERYCODE = '/v1/common/sms-code/send';
export const QUERYCODE = '/v2/common/sms-code/send';
export const SSOLOGIN = '/sso/login';
export const RESETPSD = '/sso/password/forget/restart';
